import React from 'react'
import CustomTag from 'components/CustomTag'

const StudentStatus = ({ status }) => {
  let colorType
  let tagMessage
  if (status == '-3') {
    colorType = 'grey'
    tagMessage = 'Not Interested'
  } else if (status == '-2') {
    colorType = 'red'
    tagMessage = 'Inactive'
  } else if (status == '-1') {
    colorType = 'red'
    tagMessage = 'Blacklisted'
  } else if (status == '0') {
    colorType = 'grey'
    tagMessage = 'Invite Sent'
  } else if (status == '1') {
    colorType = 'orange'
    tagMessage = 'Pending'
  } else if (status == '2') {
    colorType = 'green'
    tagMessage = 'Active'
  } else if (status == 'SHORTLISTED') {
    colorType = 'orange'
    tagMessage = status
  } else if (status == 'SCHEDULED') {
    colorType = 'blue'
    tagMessage = status
  } else if (status == 'SELECTED') {
    colorType = 'green'
    tagMessage = status
  } else if (status == 'HOLD') {
    colorType = 'grey'
    tagMessage = status
  }

  return (
    <CustomTag colorType={colorType} message={tagMessage} bordered={false} />
  )
}

export default StudentStatus
